import React from "react";
import logoLoader from "../../assets/gifs/logogifbig.gif";
import spinnerLoader from "../../assets/gifs/spinner.gif";

export const PageLoader = () => (
  <div className="fixed inset-0 flex items-center justify-center z-50">
    <img src={logoLoader} alt="Loading..." className="w-24 h-24" />
  </div>
);

export const ComponentLoader = () => (
  <div className="items-center justify-center p-3">
    <img src={spinnerLoader} alt="Loading..." className="w-12 h-12" />
  </div>
);
